import { baseOptions } from '@shared/constants/cookies'
import { type NextResponse } from 'next/server'

type NextCookieOptions = NonNullable<Parameters<NextResponse['cookies']['set']>[2]>

// Nextjs - NextResponse uses seconds for maxAge
export const maxAgeSec = 365 * 24 * 60 * 60 // 1 year, in seconds

export const nextCookieOptions: NextCookieOptions = {
  ...baseOptions,
  maxAge: maxAgeSec,
}

export const nextSecureClientOptions: NextCookieOptions = {
  ...nextCookieOptions,
  httpOnly: false,
}

export const nextSecureClientOptionsNoDomain: NextCookieOptions = {
  ...nextSecureClientOptions,
  domain: undefined,
}

// httpOnly guest ADDRESS cookie, written only by the /api/guest route handler.
// mirrors guestAddressServerCookieOptions (express, ms) with maxAge in seconds.
export const nextGuestAddressCookieOptions: NextCookieOptions = {
  ...nextSecureClientOptionsNoDomain,
  httpOnly: true,
  maxAge: 7 * 24 * 60 * 60, // 7 days, in seconds
}
